var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:\"Golos UI\";src:url(" + escape(require("./GolosUI_Bold.eot")) + ");src:url(" + escape(require("./GolosUI_Bold.eot")) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(require("./GolosUI_Bold.woff2")) + ") format(\"woff2\"),url(" + escape(require("./GolosUI_Bold.woff")) + ") format(\"woff\"),url(" + escape(require("./GolosUI_Bold.ttf")) + ") format(\"truetype\");font-weight:bold;font-style:normal}", ""]);

// exports
